import React from 'react';
import CoherencePolygon from './CoherencePolygon';
import { useLens } from './LensProvider';

export const Visualization = () => {
  const { polygonVoice } = useLens();

  return (
    <div className="visualization">
      <h2>Coherence Model</h2>
      <CoherencePolygon />
      {polygonVoice && (
        <p style={{
          fontSize: '0.8rem',
          color: 'var(--text-secondary)',
          fontStyle: 'italic',
          textAlign: 'center',
          maxWidth: '380px',
          margin: '12px auto 0',
          lineHeight: '1.6',
        }}>
          {polygonVoice}
        </p>
      )}
    </div>
  );
};
